<template>
  <page>
    <div>
      <v-card>
        <form>
          <message :messages="messages"></message>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Date Range</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex lg6 sm6 xs12>
                          <cal-picker
                            v-model="form.tranDateFrom"
                            :label="label.tranDateFrom"
                            v-validate="fromDateValidation(form.tranDateTo)"
                            :data-vv-as="label.tranDateFrom"
                            data-vv-name="tranDateFrom"
                            :error-messages="errors.collect('tranDateFrom')"
                            :min="fromDateMinDate"
                            :max="fromDateMax()"
                          ></cal-picker>
                        </v-flex>
                        <v-flex lg6 sm6 xs12>
                          <cal-picker
                            v-model="form.tranDateTo"
                            :label="label.tranDateTo"
                            v-validate="toDateValidation(form.tranDateFrom)"
                            :data-vv-as="label.tranDateTo"
                            data-vv-name="tranDateTo"
                            :error-messages="errors.collect('tranDateTo')"
                            :min="form.tranDateFrom"
                            :max="fromDateMax()"
                          ></cal-picker>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-divider></v-divider>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Selection Criteria</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <!-- <v-flex lg6 sm6 xs12>
                        <v-autocomplete :items="allSelectedList" v-model="form.branch" :label="label.branch" item-text="label" item-value="value"
                          data-vv-name="branch" :data-vv-as="label.branch" :error-messages="errors.collect('branch')" @change="doBranch"></v-autocomplete>
                      </v-flex>
                      <v-flex lg6 sm6 xs12 v-if="form.branch == 'Selected'">
                        <v-autocomplete :items="branchList" v-model="form.sBranch" :label="label.sBranch" item-text="label" item-value="value" multiple
                          data-vv-name="sBranch" :data-vv-as="label.sBranch" :error-messages="errors.collect('sBranch')" v-validate="'required'"
                          :loading="loading"></v-autocomplete>
                      </v-flex>
                      <v-flex lg6 sm6 v-else></v-flex> -->

                        <v-flex lg12 sm12 xs12>
                          <v-text-field
                            v-model="form.branch"
                            :label="label.branch"
                            :error-messages="errors.collect('branch')"
                            data-vv-name="branch"
                            :data-vv-as="label.branch"
                            append-icon="mdi-magnify"
                            @click:append="getHelpList('branch')"
                            v-validate="'required'"
                            readonly
                          ></v-text-field>
                        </v-flex>

                        <!-- <v-flex lg6 sm6 xs12>
                        <v-autocomplete :items="allSelectedList" v-model="form.interType" :label="label.interType" item-text="label" item-value="value"
                          data-vv-name="interType" :data-vv-as="label.interType" :error-messages="errors.collect('interType')" @change="doInterType"></v-autocomplete>
                      </v-flex>
                      <v-flex lg6 sm6 xs12 v-if="form.interType == 'Selected'">
                        <v-autocomplete :items="interTypeList" v-model="form.sInterType" :label="label.sInterType" item-text="label" item-value="value" multiple
                          data-vv-name="sInterType" :data-vv-as="label.sInterType" :error-messages="errors.collect('sInterType')" v-validate="'required'"
                          :loading="loading"></v-autocomplete>
                      </v-flex>
                      <v-flex lg6 sm6 v-else></v-flex> -->

                        <!-- <v-flex lg12 sm12 xs12>
                        <v-text-field v-model="form.interType" :label="label.interType" :error-messages="errors.collect('interType')" data-vv-name="interType" :data-vv-as="label.interType" append-icon="mdi-magnify" @click:append="getHelpList('interType')" v-validate="'required'" readonly></v-text-field>
                      </v-flex> -->

                        <!-- <v-flex xs12 sm12 md12 lg12>
                        <v-text-field v-model="form.interGrp" :label="label.interGrp" :error-messages="errors.collect('interGrp')" :data-vv-as="label.interGrp" data-vv-name="interGrp" append-icon="mdi-magnify" @click:append="multiInterGrpList = true" readonly v-validate="'required'"></v-text-field>
                      </v-flex> -->

                        <v-flex lg12 sm12 xs12>
                          <v-text-field
                            v-model="form.interType"
                            :label="label.interType"
                            :error-messages="errors.collect('interType')"
                            data-vv-name="interType"
                            :data-vv-as="label.interType"
                            append-icon="mdi-magnify"
                            @click:append="multiInterGrpList = true"
                            v-validate="'required'"
                            readonly
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex lg6 sm6 xs12>
                          <v-checkbox color="primary" :label="label.inclBankGrpAcct"
                            v-model="form.inclBankGrpAcct"></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
        <v-dialog v-model="helplist" width="900px" persistent>
          <helplist :apiURI="apiURI" :mode="mode" :param="param" @close="doClose" @doAssign="doAssign($event)"></helplist>
        </v-dialog>
        <v-dialog v-model="multiInterGrpList" width="900px" persistent>
          <!-- <multi-inter-grp-helplist :interGrp="form.interGrp" @close="doClose" @doAssign="doAssignInterGrp($event)"></multi-inter-grp-helplist> -->
          <multi-acct-type-help-list :acctType="form.interType" @close="doClose" @doAssign="doAssignInterGrp($event)"></multi-acct-type-help-list>
        </v-dialog>
      </v-card>
      <v-flex lg6 sm6 xs12>
        <v-checkbox color="primary" :label="label.printRptRunTime" v-model="form.printRptRunTime"></v-checkbox>
      </v-flex>
      <v-flex xs12>
        <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
          <v-icon left dark>mdi-file-export</v-icon>
          {{ label.export }}
        </v-btn>
        <v-btn-toggle dense mandatory v-model="form.format">
          <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
            <span>{{ format.label }}</span>
            <v-icon :color="format.color">{{ format.icon }}</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-flex>
    </div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import clone from 'clone'
import { checkDateRangeFrom, checkDateRangeTo } from '@/directives/common'
import { allSelectedList } from './index'
import Helplist from '../Helplist'
// import MultiInterGrpHelplist from '@/components/reports/accounts/MultiInterGrpHelplist.vue'
import MultiAcctTypeHelpList from '@/components/core/common/dialog/MultiAcctTypeHelpList'

export default {
  data() {
    return {
      label: {
        tranDateFrom: 'Transaction Date From*',
        tranDateTo: 'Transaction Date To*',
        branch: 'Branch',
        sBranch: 'Selected Branch(es)',
        interType: 'Intermediary Type',
        interGrp: 'Intermediary Group',
        sInterType: 'Selected Intermediary Type(s)',
        inclBankGrpAcct: 'Include Blank Group Account',
        printRptRunTime: 'Print Runtime Parameters',
        export: 'Export To',
        format: 'Export Format'
      },
      form: {
        tranDateFrom: '',
        tranDateTo: new Date(),
        branch: 'All',
        sBranch: '',
        interType: 'All',
        interGrp: 'All',
        sInterType: '',
        inclBankGrpAcct: false,
        printRptRunTime: true,
        runRpt: '',
        format: undefined
      },
      branchList: [],
      interTypeList: [],
      supportedFormat: [],
      loading: false,
      submitting: false,
      menu: {},
      toggleFilters: [true],
      fromDateMinDate: new Date(2000, 0, 1),
      allSelectedList: [],
      // HelpList
      helplist: false,
      apiURI: '',
      mode: '',
      param: '',
      multiInterGrpList: false,
      panel1: [0],
      panel2: [0]
    }
  },
  methods: {
    async doInit() {
      this.form.runRpt = this.runRpt
      await this.$store.dispatch('accountReportsInit')
      const apiURI = this.rptMenu.bankAccounts
      const result = await this.$http.get(apiURI)
      if (result.data) {
        const { data } = result.data
        if (data) {
          this.supportedFormat = data.format
          this.menu = extractMenu(result.data._links)
        }
      }
      this.getBranchList()
      this.getInterTypeList()
    },
    async getBranchList() {
      const apiURI = this.menu.branchList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const data = result.data.data
          this.branchList = []
          if (data) {
            for (let i in data) {
              this.branchList.push({ value: data[i].value, label: data[i].label })
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async getInterTypeList() {
      const apiURI = this.menu.interTypeList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const data = result.data.data
          this.interTypeList = []
          if (data) {
            for (let i in data) {
              this.interTypeList.push({ value: data[i].value, label: data[i].label })
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doBranch() {
      if (this.form.branch === 'All') {
        this.form.sBranch = ''
      }
    },
    doInterType() {
      if (this.form.interType === 'All') {
        this.form.sInterType = ''
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    getHelpList(fieldName) {
      this.mode = fieldName
      if (fieldName === 'branch') {
        this.apiURI = this.menu.branchList
        this.param = this.form.branch
      } else if (fieldName === 'interType') {
        this.apiURI = this.menu.interTypeList
        this.param = this.form.interType
      }
      this.helplist = true
    },
    doClose() {
      this.helplist = false
      this.multiInterGrpList = false
    },
    doAssign(Obj) {
      switch (this.mode) {
        case 'branch':
          this.form.branch = ''
          this.form.branch = Obj.finalSelectedItems.toString()
          break
        case 'interType':
          this.form.interType = ''
          this.form.interType = Obj.finalSelectedItems.toString()
          break
      }
    },
    async doAssignInterGrp(Obj) {
      // this.form.interGrp = []
      // this.form.interGrp = Obj.finalSelectedItems.toString()
      this.form.interType = []
      this.form.interType = Obj.finalSelectedItems.toString()
    },
    async processExport() {
      const apiURI = this.menu.exportBankAcct
      if (apiURI) {
        try {
          this.submitting = true
          let massageForm = clone(this.form)
          if (massageForm.sBranch) {
            massageForm.sBranch = this.form.sBranch.join()
          }
          if (massageForm.sInterType) {
            massageForm.sInterType = this.form.sInterType.join()
          }
          await this.$http.post(apiURI, massageForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    fromDateMax() {
      return new Date()
    },
    fromDateValidation(toDate1) {
      if (toDate1) {
        return 'required|checkDateRangeFrom:' + toDate1
      } else {
        return 'required|checkDateRangeFrom'
      }
    },
    toDateValidation(fromDate1) {
      if (fromDate1) {
        return 'required|checkDateRangeTo:' + fromDate1
      } else {
        return 'required|checkDateRangeTo'
      }
    }
  },
  created() {
    this.doInit()
    this.allSelectedList = allSelectedList
    this.$validator.extend('checkDateRangeFrom', checkDateRangeFrom)
    this.$validator.extend('checkDateRangeTo', checkDateRangeTo)
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.accountReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    supportedList: function(value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.form.format = value[0].value
      }
    }
  },
  mixins: [MessageMixin],
  props: {
    runRpt: {
      type: String,
      default: '1'
    }
  },
  components: {
    Helplist,
    MultiAcctTypeHelpList
    // MultiInterGrpHelplist
  }
}
</script>
